import ExpenseTrackingRequestTicketDetail from 'src/pages/v2/HrTicket/ExpenseTrackingRequestTicketDetail/ExpenseTrackingRequestTicketDetail';

export default ExpenseTrackingRequestTicketDetail;
